import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLinkSquare = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M9.5 0.75C9.5 0.34375 9.8125 0 10.25 0L15.2188 0C15.6562 0 15.9688 0.34375 15.9688 0.75V5.75C15.9688 6.1875 15.6562 6.5 15.2188 6.5C14.8125 6.5 14.4688 6.1875 14.4688 5.75V2.5625L7.5 9.53125C7.21875 9.84375 6.75 9.84375 6.46875 9.53125C6.15625 9.25 6.15625 8.78125 6.46875 8.46875L13.4375 1.5L10.25 1.5C9.8125 1.5 9.5 1.1875 9.5 0.75ZM2.25 1L6.25 1C6.65625 1 7 1.34375 7 1.75C7 2.1875 6.65625 2.5 6.25 2.5H2.25C1.8125 2.5 1.5 2.84375 1.5 3.25L1.5 13.75C1.5 14.1875 1.8125 14.5 2.25 14.5L12.75 14.5C13.1563 14.5 13.5 14.1875 13.5 13.75V9.75C13.5 9.34375 13.8125 9 14.25 9C14.6562 9 15 9.34375 15 9.75V13.75C15 15 13.9688 16 12.75 16L2.25 16C1 16 0 15 0 13.75L0 3.25C0 2.03125 1 1 2.25 1Z"
	})
});
const ForwardRef = forwardRef(SvgLinkSquare);
export default ForwardRef;
